import React from 'react';
import PropTypes from 'prop-types';
import { SAFE_ZINDEX, readOnlyText } from '@constants/mui-theme';
import { Select } from '@mui';
import { makeStyles } from 'tss-react/mui';
import * as colors from '@constants/colors';

// tss-react only supports one function for the whole styles object (theme, params), not a
// function per-rule like @mui/styles allowed — inlined here using params.selectStyles.
const useStyles = makeStyles()((theme, { selectStyles }) => ({
  select: {
    color: colors.dotmapsBlack80,
    marginLeft: '0.5rem',
    '&:focus': {
      backgroundColor: 'transparent',
      color: colors.dotmapsBlack80
    },
    '&.Mui-disabled': {
      ...readOnlyText
    },
    ...selectStyles?.root
  },
  icon: {
    '&.Mui-disabled': {
      color: colors.dotmapsBlack40
    }
  }
}));

const CustomSelect = props => {
  const { selectStyles = { root: {}}, ...other } = props;
  const { classes } = useStyles({ selectStyles });
  return (
    <Select
      {...other}
      classes={{
        select: classes.select,
        icon: classes.icon
      }}
    />
  );
};

CustomSelect.propTypes = {
  selectStyles: PropTypes.object
};

const SelectField = ({
  children, id, labelId, onChange, renderValue, value, ...other
}) => (
  <CustomSelect
    {...other}
    id={id}
    labelId={labelId}
    onChange={onChange}
    renderValue={renderValue}
    value={value}
    MenuProps={{
      style: SAFE_ZINDEX
    }}
  >
    {children}
  </CustomSelect>
);

SelectField.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  labelId: PropTypes.string,
  onChange: PropTypes.func,
  renderValue: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default SelectField;
